import React, { useContext } from 'react'

import { UserAppConfigStoreContext } from '../../contexts'
import { UserAppConfigStore } from '../../stores/UserAppConfigStore/UserAppConfigStore'

const useUserAppConfigStore = (): UserAppConfigStore => {
   const userAppConfigStore = useContext(UserAppConfigStoreContext)

   if (!userAppConfigStore) {
      throw new Error('Expected to be wrapped in Current User Store Provider')
   }

   return userAppConfigStore
}

export { useUserAppConfigStore }
